import scss from "./Loader.module.scss";

//Images
import glass from "../assets/loaders/glass.svg";
import spinner from "../assets/loaders/spinner.svg";
import ring from "../assets/loaders/ring.svg";

export const Loader = () => {
  return (
    <div className={scss.loader}>
      <h4 className={scss.loadingText}>Loading...</h4>
      <div className={scss.svgWrapper}>
        <div>
          <img className={scss.glass} src={glass} alt="" />
        </div>
        <div>
          <img className={scss.spinner} src={spinner} alt="" />
        </div>
        <div>
          <img className={scss.ring} src={ring} alt="" />
        </div>
      </div>
    </div>
  );
};
